import * as React from 'react';

import {ShowHideButton} from '../button/show-hide-button/show-hide-button';
import {ProgressDonut} from '../progress-bar/progress-donut';
import {Body} from '../typography/body';

import type {Checklist} from './types';

import styles from './onboarding-checklist-header.module.css';

const PARTY_POPPER = '\u{1F389}';

type Props = {
    checklist: Checklist;
    completedCount: number;
    totalCount: number;
    checklistIsComplete: boolean;
    expandProps?: {
        isExpanded: boolean;
        onToggleExpand: () => void;
    };
    title?: string;
};

export function OnboardingChecklistHeader(props: Props) {
    const {title = 'Get started with Nutshell'} = props;

    const doneText = props.checklistIsComplete
        ? 'You’re done!'
        : `${props.completedCount} of ${props.totalCount} done`;

    return (
        <div className={styles.container}>
            <div className='mr-16'>
                <Body size='large' isBold={true}>
                    {title}
                </Body>
                <div className={styles.done}>{doneText}</div>
            </div>
            <div className='flex align-center'>
                {props.checklistIsComplete ? (
                    <span className={styles.party}>{PARTY_POPPER}</span>
                ) : undefined}
                <ProgressDonut percentComplete={props.checklist.percentComplete} height={50} />
                {props.expandProps ? (
                    <div className={styles.arrow}>
                        <ShowHideButton
                            variant='text-secondary'
                            noPadding={true}
                            isShown={props.expandProps.isExpanded}
                            onToggle={props.expandProps.onToggleExpand}
                        />
                    </div>
                ) : undefined}
            </div>
        </div>
    );
}
